import { type PropsWithChildren, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { type RefinementListProps, useRefinementList } from 'react-instantsearch';
import { type RepubCountry } from '@cx-web/domain-types';
import { type RefinementListItem } from 'instantsearch.js/es/connectors/refinement-list/connectRefinementList';

import { Button, Checkbox, CheckboxGroup } from '~/apps/product-plus/components/cxy/cxy.ts';

import styles from './styles/BetTypeFilters.module.css';

export const CheckboxFilter = ({
  children,
  childrenPlacement = 'after',
  isDisabled = false,
  label,
  repubCountry,
  trackChange,
  transformFieldLabel,
  ...refinementProps
}: PropsWithChildren<
  RefinementListProps & {
    childrenPlacement?: 'before' | 'after';
    isDisabled?: boolean;
    label?: string;
    repubCountry: RepubCountry;
    trackChange?: (value: string) => void;
    transformFieldLabel?: (item: RefinementListItem, lng: { repubCountry: RepubCountry; today: string }) => ReactNode;
  }
>) => {
  const { canToggleShowMore, isShowingMore, items, refine, toggleShowMore } = useRefinementList({
    ...refinementProps,
  });

  const { t } = useTranslation();

  return (
    <>
      <CheckboxGroup aria-label={label || refinementProps.attribute} className={styles.select}>
        {childrenPlacement === 'before' && children}
        {items.map(item => {
          return (
            <Checkbox
              checked={item.isRefined}
              disabled={isDisabled}
              key={item.value}
              onCheckedChange={() => {
                trackChange?.(item.value);
                refine(item.value);
              }}
              value={item.value}
            >
              {transformFieldLabel ? transformFieldLabel(item, { repubCountry, today: t('CX_TODAY') }) : item.label}
            </Checkbox>
          );
        })}
        {childrenPlacement === 'after' && children}
      </CheckboxGroup>
      {canToggleShowMore && (
        <Button onClick={toggleShowMore} variant="ghost">
          {isShowingMore ? t('CX_SHOW_LESS') : t('CX_SHOW_MORE')}
        </Button>
      )}
    </>
  );
};
